class WisteriaConnectController extends AbstractIntegrationController
	@register()

	integrationId: 'wisteria'
